// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// local
// views
// actions
import { closeChangeStatusModal } from 'app/redux/actions/modal/change-status-modal.action';
import { reactivate, deactivate } from 'app/redux/actions/health-professional.action';
import ChangeStatusModal from 'app/components/modals/ChangeStatusModal';

class HealthProfessionalChangeStatus extends Component {
  componentWillUnmount = () => this.onClose();

  onClose = () => this.props.dispatch(closeChangeStatusModal());

  onSubmit = (id, status) => {
    if (status === 0) {
      this.props.dispatch(reactivate(id));
    } else {
      this.props.dispatch(deactivate(id));
    }
  };

  render() {
    const { changeStatusModal, dispatch } = this.props;
    const { isOpened, payload, error } = changeStatusModal;

    const options = {
      dispatch,
      onConfirmModal: this.onSubmit,
      isOpened,
      error,
      title: 'profissional',
      ...payload
    };

    return <ChangeStatusModal id='profession-change-status-modal' options={options} />;
  }
}

HealthProfessionalChangeStatus.propTypes = {
  changeStatusModal: PropTypes.any,
  dispatch: PropTypes.func,
  modal: PropTypes.object
};

const mapStateToProps = state => ({
  changeStatusModal: state.changeStatusModal
});

export default connect(mapStateToProps)(HealthProfessionalChangeStatus);
